/**
 * @description 埋点策略工厂 - 集中配置管理方案
 * @author zcq
 * @date 2025-04-18
 */

import { EBurialFramework, IBurialPointStrategy, IStrategyConfig, EEnvironment } from './types';
import { ArmsStrategy } from './providers';

/**
 * 埋点工厂 - 创建埋点策略
 */
export class BurialPointFactory {
  /**
   * 根据策略配置创建相应的埋点策略
   */
  public static createStrategy(
    strategyConfig: IStrategyConfig,
    environment: EEnvironment
  ): IBurialPointStrategy {
    return new ArmsStrategy(strategyConfig, environment);
  }
}
